import { createFileRoute } from "@tanstack/react-router";
import { OppsummeringPage } from "@/features/bestillinger/pages";

export const Route = createFileRoute("/_app/bestilling/ny/oppsummering/")({
  component: OppsummeringPage,
  head: () => ({
    meta: [
      {
        title: "Oppsummering | Norgespris for Fjernvarme",
      },
    ],
  }),
});
